// // utils/mapEmpanelmentToStore.js
// import useRegistrationStore from './useRegistrationStore';

// export const mapEmpanelmentDataToStore = (empanelmentData) => {
//     if (!empanelmentData) return;

//     const {
//         setProviderData,
//         setAuthorityData,
//         setFormData,
//         setSelectedServices,
//         setSelectedSpecialities
//     } = useRegistrationStore.getState();
//     const removeAmPm = (time) => {
//         if (!time) return '09:00';

//         return time
//             .replace(/\s?(AM|PM)/i, '')
//             .trim();
//     };

//     // Map Provider Data with proper type conversion
//     const providerDataToSet = {
//         providerType: empanelmentData.ProviderType_ID || '',
//         facilityName: empanelmentData.ProviderName || '',
//         isBranch: empanelmentData.IsThisBranch || false,
//         mainBranchHANumber: empanelmentData.MainBranchName || '',
//         healthAuthority: empanelmentData.HealthAuthority_ID || '',
//         country: empanelmentData.Provider_Address_Country_ID || '',
//         emirates: empanelmentData.Provider_Address_State_ID || '',
//         city: empanelmentData.Provider_Address_City_ID || '',
//         area: empanelmentData.Provider_Address_CityArea_ID || '',
//         street: empanelmentData.Provider_Address_Street || '',
//         location: empanelmentData.Provider_Address || '',
//         poBox: empanelmentData.POBox || '',
//         landline: empanelmentData.landline || '',
//         website: empanelmentData.Provider_Address_Website || '',
//         openTime: removeAmPm(
//             empanelmentData.BusinessHr_Sunday_Thursday_Morning_Open
//         ),
//         closeTime: removeAmPm(
//             empanelmentData.BusinessHr_Sunday_Thursday_Morning_Close
//         ),
//     };

//     setProviderData(providerDataToSet);

//     // Map Authority Data
//     setAuthorityData({
//         facilityLicenseNo: empanelmentData.Provider_HA_RegNo || '',
//         facilityLicenseExpiry: empanelmentData.Provider_HA_RegNoValidToDate
//             ? new Date(empanelmentData.Provider_HA_RegNoValidToDate).toISOString().split('T')[0]
//             : '',
//         trackLicNo: empanelmentData.Provider_HA_EstablishmentID?.toString() || '',
//         trackLicExpiry: '', // Not in API response
//         tradeLicNo: empanelmentData.Provider_Trade_LicNo || '',
//         tradeLicName: empanelmentData.Provider_Trade_LicName || '',
//         tradeLicExpiry: empanelmentData.Provider_Trade_LivNoValidToDate
//             ? new Date(empanelmentData.Provider_Trade_LivNoValidToDate).toISOString().split('T')[0]
//             : '',
//         signatory1Name: empanelmentData.Signatory_Name || '',
//         signatory1Designation: empanelmentData.Signatory_Designation || '',
//         signatory1EmiratesId: empanelmentData.Signatory_EmiratesID || '',
//         signatory1ContactNo: empanelmentData.Signatory_ContactNo || '',
//         signatory1Remarks: empanelmentData.Signatory_Remarks || '',
//         networkInsuranceName1: empanelmentData.ContactDtl_NetAndInsDep_Name || '',
//         networkInsuranceEmail1: empanelmentData.ContactDtl_NetAndInsDep_eMail || '',
//         networkInsuranceContact1: empanelmentData.ContactDtl_NetAndInsDep_ContactNo || '',
//         accountsName1: empanelmentData.ContactDtl_AccountsDep_Name || '',
//         accountsEmail1: empanelmentData.ContactDtl_AccountsDep_eMail || '',
//         accountsContact1: empanelmentData.ContactDtl_AccountsDep_ContactNo || '',
//         administrationName1: empanelmentData.ContactDtl_AdminDep_Name || '',
//         administrationEmail1: empanelmentData.ContactDtl_AdminDep_eMail || '',
//         administrationContact1: empanelmentData.ContactDtl_AdminDep_ContactNo || '',
//     });

//     // Map Form Data
//     setFormData({
//         patientCapacityOP: empanelmentData.Facility_PatientCapacity_OP?.toString() || '',
//         patientCapacityIP: empanelmentData.Facility_PatientCapacity_IP?.toString() || '',
//         patientCapacityDC: empanelmentData.Facility_PatientCapacity_DC?.toString() || '',
//         discount: empanelmentData.RequestDiscount || 0,
//         // Note: File fields need to be handled separately as API returns filenames, not file objects
//         tradeLicenseFile: empanelmentData.DocUpload_TradeLic_Name || null,
//         tariffListFile: empanelmentData.DocUpload_TariffList_Name || null,
//         haLicenseFile: empanelmentData.DocUpload_HALic_Name || null,
//         signatoryEmiratesIdFile: empanelmentData.Signatory_EmiratesID_FileName || null,
//         otherFiles: empanelmentData.DocUpload_Others_Name || null,
//     });

//     // Helper: safely parse comma-separated IDs
//     const parseIds = (value) => {
//         if (!value || value === 'null') return [];

//         return value
//             .split(',')
//             .map(id => Number(id.trim()))
//             .filter(Number.isFinite); // removes NaN
//     };

//     // Parse Facility IDs
//     const facilityIDs = parseIds(empanelmentData?.FacilityIDs);

//     // Parse Speciality IDs
//     const specialityIDs = parseIds(empanelmentData?.MedicalSpecialitiesIDs);

//     setSelectedServices(facilityIDs);
//     setSelectedSpecialities(specialityIDs);

//     // Return the empanelment ID and reference number for further use
//     return {
//         empanelmentId: empanelmentData.Empanelment_ID,
//         refNo: empanelmentData.Empanelment_RefNo,
//     };
// };






// utils/mapEmpanelmentToStore.js
import useRegistrationStore from './useRegistrationStore';

export const mapEmpanelmentDataToStore = (empanelmentData) => {
    if (!empanelmentData) return;

    const {
        setProviderData,
        setAuthorityData,
        setFormData,
        setSelectedServices,
        setSelectedSpecialities
    } = useRegistrationStore.getState();

    const removeAmPm = (time) => {
        if (!time) return '09:00';

        // Remove AM / PM
        const cleanTime = time.replace(/\s?(AM|PM)/i, '').trim();

        // Split hours and minutes
        let [hours, minutes] = cleanTime.split(':');

        // Pad hour to 2 digits
        hours = hours.padStart(2, '0');

        return `${hours}:${minutes}`;
    };


    // Map Provider Data with proper type conversion
    // IMPORTANT: Store empanelmentRefNo for file downloads
    const providerDataToSet = {
        providerType: empanelmentData.ProviderType_ID || '',
        facilityName: empanelmentData.ProviderName || '',
        isBranch: empanelmentData.IsThisBranch || false,
        mainBranchHANumber: empanelmentData.MainBranchName || '',
        healthAuthority: empanelmentData.HealthAuthority_ID || '',
        country: empanelmentData.Provider_Address_Country_ID || '',
        emirates: empanelmentData.Provider_Address_State_ID || '',
        city: empanelmentData.Provider_Address_City_ID || '',
        area: empanelmentData.Provider_Address_CityArea_ID || '',
        street: empanelmentData.Provider_Address_Street || '',
        location: empanelmentData.Provider_Address || '',
        poBox: empanelmentData.POBox || '',
        landline: empanelmentData.landline || '',
        website: empanelmentData.Provider_Address_Website || '',
        openTime: removeAmPm(
            empanelmentData.BusinessHr_Sunday_Thursday_Morning_Open
        ),
        closeTime: removeAmPm(
            empanelmentData.BusinessHr_Sunday_Thursday_Morning_Close
        ),
        // Store reference number for file downloads
        empanelmentRefNo: empanelmentData.Empanelment_RefNo || '',
        empanelmentId: empanelmentData.Empanelment_ID || 0,
    };

    setProviderData(providerDataToSet);

    // Map Authority Data
    setAuthorityData({
        facilityLicenseNo: empanelmentData.Provider_HA_RegNo || '',
        facilityLicenseExpiry: empanelmentData.Provider_HA_RegNoValidToDate
            ? new Date(empanelmentData.Provider_HA_RegNoValidToDate).toISOString().split('T')[0]
            : '',
        trackLicNo: empanelmentData.Provider_HA_EstablishmentID?.toString() || '',
        trackLicExpiry: '', // Not in API response
        tradeLicNo: empanelmentData.Provider_Trade_LicNo || '',
        tradeLicName: empanelmentData.Provider_Trade_LicName || '',
        tradeLicExpiry: empanelmentData.Provider_Trade_LivNoValidToDate
            ? new Date(empanelmentData.Provider_Trade_LivNoValidToDate).toISOString().split('T')[0]
            : '',
        signatory1Name: empanelmentData.Signatory_Name || '',
        signatory1Designation: empanelmentData.Signatory_Designation || '',
        signatory1EmiratesId: empanelmentData.Signatory_EmiratesID || '',
        signatory1ContactNo: empanelmentData.Signatory_ContactNo || '',
        signatory1Remarks: empanelmentData.Signatory_Remarks || '',
        networkInsuranceName1: empanelmentData.ContactDtl_NetAndInsDep_Name || '',
        networkInsuranceEmail1: empanelmentData.ContactDtl_NetAndInsDep_eMail || '',
        networkInsuranceContact1: empanelmentData.ContactDtl_NetAndInsDep_ContactNo || '',
        accountsName1: empanelmentData.ContactDtl_AccountsDep_Name || '',
        accountsEmail1: empanelmentData.ContactDtl_AccountsDep_eMail || '',
        accountsContact1: empanelmentData.ContactDtl_AccountsDep_ContactNo || '',
        administrationName1: empanelmentData.ContactDtl_AdminDep_Name || '',
        administrationEmail1: empanelmentData.ContactDtl_AdminDep_eMail || '',
        administrationContact1: empanelmentData.ContactDtl_AdminDep_ContactNo || '',
    });

    // Map Form Data
    // Store filenames as strings - these will be detected in DocumentsStep
    setFormData({
        patientCapacityOP: empanelmentData.Facility_PatientCapacity_OP?.toString() || '',
        patientCapacityIP: empanelmentData.Facility_PatientCapacity_IP?.toString() || '',
        patientCapacityDC: empanelmentData.Facility_PatientCapacity_DC?.toString() || '',
        discount: empanelmentData.RequestDiscount || 0,
        // File fields: API returns filenames (strings), not File objects
        // DocumentsStep will detect these as existing files and show download option
        // tradeLicenseFile: empanelmentData.DocUpload_TradeLic_Name || null,
        // tariffListFile: empanelmentData.DocUpload_TariffList_Name || null,
        // haLicenseFile: empanelmentData.DocUpload_HALic_Name || null,
        // signatoryEmiratesIdFile: empanelmentData.Signatory_EmiratesID_FileName || null,
        // otherFiles: empanelmentData.DocUpload_Others_Name || null,
    });

    // Helper: safely parse comma-separated IDs
    const parseIds = (value) => {
        if (!value || value === 'null') return [];

        return value
            .split(',')
            .map(id => Number(id.trim()))
            .filter(Number.isFinite); // removes NaN
    };

    // Parse Facility IDs
    const facilityIDs = parseIds(empanelmentData?.FacilityIDs);

    // Parse Speciality IDs
    const specialityIDs = parseIds(empanelmentData?.MedicalSpecialitiesIDs);

    setSelectedServices(facilityIDs);
    setSelectedSpecialities(specialityIDs);

    // Return the empanelment ID and reference number for further use


    return {
        empanelmentId: empanelmentData.Empanelment_ID,
        refNo: empanelmentData.Empanelment_RefNo,
    };
};